const animationTime = 400; // NOTE: follow SCSS $transition-time

export { animationTime };
export const ENABLE_BUTTON_SUBMIT_ACTION_NAME = "EnableButtonSubmit";
